import { Component, OnInit } from "@angular/core";
import { Methods } from "../../shared/methods";
import { SaleService } from "../../services/sale.service";
import { Router, ActivatedRoute } from "@angular/router";
import { SaleOrder } from "../../models/saleOrder";
import { LocationService } from "../../services/location.service";
import { TermService } from "../../services/saleterm.service";
import { ScrapService } from "../../services/scrap.service";
import { UserService } from "../../services/user.service";
import { Scrap, Objet } from "../../models/scrap";
import { Title } from '@angular/platform-browser';
import { MailBox } from "../../shared/components/mail-box/mail-box.component";
import { MatDialog } from "@angular/material/dialog";
import swal from "sweetalert2";

declare const $: any;

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css'],
  providers: [UserService, TermService, LocationService, ScrapService],
})
export class InvoiceComponent implements OnInit {
  public identity;
  public token;
  public mtds: Methods = new Methods();
  public so: SaleOrder = new SaleOrder();
  public edit = true;
  public aguante = false;
  public loading = false;
  public saving = false;
  public tab = null;
  public cancelando = false;

  public userlogged;
  public apiCompany;

  public nuevo: boolean;
  public netTerms: Array<any> = [];
  public conditions: Array<any> = [];
  public repsList: Array<any> = [];
  public currencies: Array<any> = [];
  public locations: Array<any> = [];
  public cotents: Array<any> = [];
  public userLocations: Array<any> = [];

  public invoice = {
    account: '',
    arinvoicedetailid: '',
    description: '',
    extendeddescription: '',
    invoice: '',
    billtocontactfax: '',
    billtocontactname: '',
    billtocontactphone: '',
    billtoemail: '',
    earlyinvoice: '',
  }

  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private _router: Router,
    public dialog: MatDialog,
    private _locationService: LocationService,
    private _userService: UserService,
    private _soService: SaleService,
    private _scrapService: ScrapService,
    private _termService: TermService
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    console.log(this.identity);
    this.token = JSON.parse(localStorage.getItem("token"));

    this.route.params.subscribe((params) => {
      this.nuevo = true;
      if (params["id"] !== "new") {
        this.titleService.setTitle( 'Loading...' );
        this.show(Number(params["id"]), true);
        this.nuevo = false;
      } else {
        this.so.date = this.mtds.getFecha(new Date());
        // this.so.duedate = this.mtds.getFecha(new Date());
      }

      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.status === "success") {
            this.userlogged = response.data;
            this.apiCompany = this.userlogged.companyLinked.apiToken;
            console.log(this.userlogged);
            /*
            if (this.nuevo) {
              if (this.userlogged.location) {
                this.so.shipfromlocation_id = this.userlogged.location.id;
                this.so.shipfromcompany =
                  this.userlogged.location.companyLinked.name;
                this.so.shipfromaddress1 = this.userlogged.location.address;
                this.so.shipfromaddress2 = this.userlogged.location.address2;
                this.so.shipfromcity = this.userlogged.location.city;
                this.so.shipfromstate = this.userlogged.location.colonia;
                this.so.shipfrompostalcode = this.userlogged.location.zipCode;
                this.so.shipfromcountry = this.userlogged.location.country;
                this.so.shipfromcountry = this.userlogged.country;
                this.so.shipfromcontact =
                  this.userlogged.name + " " + this.userlogged.surname;
                this.so.shipfromphone = this.userlogged.phone;
                this.so.shipfromemail = this.userlogged.email;
              } else {
                this.so.shipfromlocation_id = "headq";
                this.so.shipfromcompany = this.userlogged.companyLinked.name;
                this.so.shipfromaddress1 = this.userlogged.address;
                this.so.shipfromaddress2 = this.userlogged.address2;
                this.so.shipfromcity = this.userlogged.city;
                this.so.shipfromstate = this.userlogged.colonia;
                this.so.shipfrompostalcode = this.userlogged.zipCode;
                this.so.shipfromcountry = this.userlogged.country;
                this.so.shipfromcontact =
                  this.userlogged.name + " " + this.userlogged.surname;
                this.so.shipfromphone = this.userlogged.phone;
                this.so.shipfromemail = this.userlogged.email;
              }
            }
            */
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });

    this._userService
      .getAllUsersType(this._userService.getToken(), "workers")
      .subscribe((response) => {
        this.repsList = response.data;
      });

    this._locationService.getConditions(this.token).subscribe((response) => {
      console.log(response.data);
      this.conditions = response.data;
    });

    this._locationService.getCurrencies(this.token).subscribe((response) => {
      this.currencies = response.data;
    });

    this._locationService
      .getLocationsByUser(this.token, this.identity.sub)
      .subscribe((response) => {
        this.userLocations = response.data;
        console.log(this.userLocations);
      });

    this._scrapService.getCategories(this.token).subscribe((response) => {
      for (let item of response.data) {
        let categoria: Objet = new Objet();
        categoria.id = item.id;
        categoria.name = item.name;
        this.cotents.push(categoria);
      }
    });

    this.getNetTerms();
  }

  getNetTerms() {
    this._termService
      .getTerms(JSON.parse(localStorage.getItem("token")))
      .subscribe((response) => {
        console.log(response);
        this.netTerms = response.data;
      });
  }

  ngOnInit() {}

  sendMail() {
    let dialogRef = this.dialog.open(MailBox, {
      width: "80%",
      data: {
        from: [this.userlogged.location.email],
        to: [this.so.contactemail],
        cc: [],
        bcc: [],
        element_id: this.so.id,
        type: "SO",
        subject: `SO# ${this.so.so}`,
        msg: "",
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result != "undefined") {
      }
    });
  }

  show(id, getToLocations = false) {
    this.loading = true;
    this._soService.getOneSO(id).subscribe(
      (response) => {
        console.log(response);

        if (response.code === 200) {
          this.tab = 1;
          this.edit = response.data.status !== "Voided";

          this.invoice.account = response.data.invoicesAccount;
          this.invoice.arinvoicedetailid = response.data.invoicesArinvoicedetailid;
          this.invoice.description = response.data.invoicesDescription;
          this.invoice.extendeddescription = response.data.invoicesExtendeddescription;
          this.invoice.invoice = response.data.invoicesInvoice;
          this.invoice.billtocontactfax = response.data.invoicesBilltocontactfax;
          this.invoice.billtocontactname = response.data.invoicesBilltocontactname;
          this.invoice.billtocontactphone = response.data.invoicesBilltocontactphone;
          this.invoice.billtoemail = response.data.invoicesBilltoemail;
          this.invoice.earlyinvoice = response.data.invoicesEarlyinvoice;
          this.so.setValues(response);

          this.titleService.setTitle( `#${this.so.so} Sale Order` );

          // if (getToLocations) {
          //   this._locationService
          //     .getLocationsByUser(this.token, this.so.contactcontactuser_id)
          //     .subscribe((response2) => {
          //       console.log(response2);
          //       this.locations = response2.data;
          //     });
          // }

          this.loading = false;
        } else {
          this.loading = false;
          this.mtds.notifyError(response.msg, response.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  checkHideLine() {
    if (this.edit) {
      if (this.so.hideline === 1) {
        this.so.hideline = 0;
      } else {
        this.so.hideline = 1;
      }
    }
  }

  subTotal() {
    let total: number =
      Number(this.so.extracost) + Number(this.so.extendedcost);
    return total.toFixed(2);
  }

  total() {
    let total: number =
      Number(this.so.extracost) +
      Number(this.so.extendedcost) +
      Number(this.so.tax) +
      Number(this.so.freight);
    return total.toFixed(2);
  }

  pdf() {
    window.open(
      "https://itaderp.com/backend/reports/view-so.php?id=" +
        this.so.id +
        "&apitoken=" +
        this.apiCompany
    );
  }

  voidpp() {
    swal.fire({
      title: "Do Void",
      text: "Are you sure to do void this sale order?",
    
      showCancelButton: true,
      buttonsStyling: false,
     
      customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continue",
    }).then(
      function (result) {
        if (result.value) {
          this._soService.doVoid(this.so.id).subscribe((r) => {
            console.log(r);
            if (r.code === 400 && r.msg === "Authorization not valid") {
              this.mtds.notifyError("Your session has expired");
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            } else if (r.status === "success") {
              this.edit = false;
              this.so.status = r.data.status;
            } else {
              this.mtds.notifyError(r.msg, r.code);
            }
          });
        }
      }.bind(this)
    );
  }

  changeCustomer() {
    $("#changeCustomer").modal("show");
    this.aguante = true;
    setTimeout(
      function () {
        this.aguante = false;
      }.bind(this),
      250
    );
  }

  closeChangeCustomer() {
    $("#changeCustomer").modal("hide");
  }

  seleccionarCliente(cliente, save = true) {
    console.log(cliente);
    if (cliente.id) {
      $("#changeCustomer").modal("hide");
      if (this.so.rep_id === null) {
        this.so.rep_id = this.identity.sub;
      }
      this.so.customer_id = cliente.id;
      this.so.term = cliente.term;
      this.so.customerName =
        cliente.name +
        " " +
        cliente.surname +
        " #" +
        cliente.id +
        " - " +
        cliente.companyLinked.name;

      this.so.contactcontactuser_id = cliente.id;
      this.so.contactcontact = cliente.name + " " + cliente.surname;
      this.so.contactphone = cliente.phone;
      this.so.contactemail = cliente.email;
      if (cliente.currency !== null) {
        this.so.currency = cliente.currency.name;
      }
      if (cliente.term !== null) {
        this.so.term = Number(cliente.term.id);
      } else if (cliente.companyLinked !== null) {
        this.so.term = Number(cliente.companyLinked.termsId);
      }
      this.so.conditions_id =
        cliente.condition !== null ? cliente.condition.id : null;
      this.so.contactaddress1 = cliente.address;
      this.so.contactaddress2 = cliente.address2;
      this.so.contactcity = cliente.city;
      this.so.contactstate = cliente.colonia;
      this.so.contaccountry = cliente.country;
      this.so.contactpostalcode = cliente.zipCode;
      this.so.contactcompany = cliente.companyLinked.name;

      this.so.shiptocompany = cliente.companyLinked.name;
      // this.companyLinked = cliente.companyLinked.id;
      this.so.shiptocontact = cliente.name + " " + cliente.surname;
      this.so.shiptoemail = cliente.email;
      this.so.shiptophone = cliente.phone;

      if (cliente.location !== null) {
        this.so.shiptolocation_id = cliente.location.id;
        this.so.shiptoaddress1 = cliente.location.address;
        this.so.shiptoaddress2 = cliente.location.address2;
        this.so.shiptocity = cliente.location.city;
        this.so.shiptostate = cliente.location.colonia;
        this.so.shiptocountry = cliente.location.country;
        this.so.shiptopostalcode = cliente.location.zipCode;
      } else {
        this.so.shiptolocation_id = "headq";
        this.so.shiptoaddress1 = cliente.address;
        this.so.shiptoaddress2 = cliente.address2;
        this.so.shiptocity = cliente.city;
        this.so.shiptostate = cliente.colonia;
        this.so.shiptocountry = cliente.country;
        this.so.shiptopostalcode = cliente.zipCode;
      }
      this._locationService
        .getLocationsByUser(this.token, this.so.contactcontactuser_id)
        .subscribe((response2) => {
          console.log(response2);
          this.locations = response2.data;
        });
      if (save) {
        this.save(true, false);
      }
    }
  }

  save(changeTab = false, msge = true) {
    this.saving = true;
    this._soService.save(this.so).subscribe(
      (response) => {
        console.log(response);

        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.so.setValues(response);

          if (changeTab) {
            this.tab = 1;
          }

          if (msge) {
            this.mtds.notifySuccess("Changes have been saved successfully");
          }
        }
        this.saving = false;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
        if (this.so.id === null) {
          this._router.navigate(["/sales-orders"]);
        }
      }
    );
  }
}